import type { NotificationItem, NotificationKind } from './types.js';

export function sortNotifications(
  items: NotificationItem[],
): NotificationItem[] {
  const kindOrder: Record<NotificationKind, number> = {
    stale_provisional: 0,
    week_release: 1,
    overdue_invoices: 2,
    renewal: 3,
    sync: 4,
    scheduled_job: 5,
  };
  return [...items].sort((a, b) => {
    if (a.priority !== b.priority) return a.priority - b.priority;
    if (kindOrder[a.kind] !== kindOrder[b.kind]) {
      return kindOrder[a.kind] - kindOrder[b.kind];
    }
    return a.id.localeCompare(b.id);
  });
}

export type { NotificationItem };
